(ns frontend.ux-overhaul.listing.investor.view
  (:require [common.localization :as loc]
            [common.opensearch.row :as os-row]
            [common.util :as cu]
            [frontend.routing :as routing]
            [frontend.state.current-session :as session]
            [frontend.ux-overhaul.listing.generic.bulk-actions :as bulk-actions]
            [frontend.ux-overhaul.listing.generic.event :as generic-event]
            [frontend.ux-overhaul.listing.generic.facets-event :as generic-facets-event]
            [frontend.ux-overhaul.listing.generic.menu-actions :as menu-actions]
            [frontend.ux-overhaul.listing.generic.view :as listing]
            [frontend.ux-overhaul.listing.investor.event :as investor-event]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(def listing-id "investor-listing")

(defn- open-investor!
  [value]
  (when-let [entity-id (os-row/entity-id value)]
    (routing/open-entity {:db/id       entity-id
                          :entity/type :entity.type/investor})))

(def page-content
  (r/create-class
   {:component-did-mount
    (fn []
      (rf/dispatch
       [::generic-event/init
        {:listing-id           listing-id
         :entity-type          :entity.type/investor
         :pipeline-id          nil
         :filters              {:enabled? true
                                :view-id :investor
                                :load-facets-event [::generic-facets-event/load-facets]}
         :available-view-modes #{:grid :kanban :gallery :list}
         :toolbar-actions      [{:id       :create-investor
                                 :label    (loc/tr :investor-add-button)
                                 :visible? (not (session/is-read-only-user?))
                                 :enabled? true
                                 ;; An investor wraps a legal entity that is either a
                                 ;; person or a company, so the user picks which. This is
                                 ;; the choice the legacy grid's Create menu offers too.
                                 :items    (cu/concatv
                                            [{:id             :create-investor-legal-entity-type-title
                                              :section-label? true
                                              :label          (loc/tr :select-investor-type)}]
                                            (mapv (fn [entity-type]
                                                    {:id    (keyword "create-investor" (name entity-type))
                                                     :label (loc/tr entity-type)
                                                     :event [::investor-event/create-investor
                                                             {:legal-entity-type entity-type}]})
                                                  [:entity.type/person :entity.type/company]))}
                                {:id                  :bulk-edit-investors
                                 :label               (loc/tr :bulk-edit)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :event               [::investor-event/open-bulk-edit {:listing-id listing-id}]}
                                {:id                  :bulk-delete-investors
                                 :label               (loc/tr :confirm-delete-selected-button)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :variant             :danger
                                 :event               [::investor-event/bulk-delete-selected {:listing-id listing-id}]}
                                {:id       :export-investors
                                 :label    (loc/tr :save-as-excel)
                                 :visible? true
                                 :enabled? true
                                 :event    [::investor-event/export-grid {:listing-id listing-id}]}
                                {:id       :export-investors-with-persons
                                 :label    (loc/tr :save-as-excel-all-data)
                                 :visible? true
                                 :enabled? true
                                 :event    [::investor-event/export-grid-with-persons {:listing-id listing-id}]}
                                (menu-actions/field-requirements-action {:entity-type :entity.type/investor})]}]))

    :component-will-unmount
    (fn []
      (rf/dispatch [::generic-event/destroy listing-id]))

    :reagent-render
    (fn []
      [:<>
       [listing/view
        {:listing-id               listing-id
         :title                    (loc/tr :investors)
         :show-view-mode-selector? true
         :query-placeholder        (loc/tr :listing.investor/search-placeholder)
         :on-create-first-item     #(rf/dispatch [::investor-event/create-investor])
         :on-row-clicked           open-investor!
         :on-card-clicked          open-investor!}]
       [bulk-actions/bulk-edit-modal
        {:listing-id  listing-id
         :entity-type :entity.type/investor}]
       [menu-actions/field-requirements-modal]])}))
